module.exports = __webpack_public_path__ + "static/media/nrdelogo.bb2b0073.jpg";